<div class="page">

  <!-- Header -->
  <div class="page-header">
    <div class="header-left">
      <button class="btn-back" (click)="goBack()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
        Back
      </button>
      <div>
        <h1>Banner #{{ banner?.id || '...' }}</h1>
        <p>{{ banner?.is_active ? 'Active' : 'Inactive' }}</p>
      </div>
    </div>
    <div class="header-actions" *ngIf="banner && !isEditMode">
      <button class="btn-secondary" (click)="enableEdit()">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
        Edit
      </button>
      <button class="btn-danger" (click)="confirmDelete()">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/>
          <path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
        </svg>
        Delete
      </button>
    </div>
  </div>

  <!-- Loading -->
  <div class="loading-state" *ngIf="isLoading">
    <div class="spinner-lg"></div>
    <p>Loading banner...</p>
  </div>

  <ng-container *ngIf="!isLoading && banner">

    <!-- Success Toast -->
    <div class="toast-success" *ngIf="successMessage">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="20 6 9 17 4 12"/>
      </svg>
      {{ successMessage }}
    </div>

    <!-- ── VIEW MODE ── -->
    <div *ngIf="!isEditMode">
      <div class="detail-card">

        <!-- Image -->
        <div class="detail-section">
          <h2 class="section-title">Image</h2>
          <div class="image-frame">
            <img *ngIf="banner.image_url" [src]="banner.image_url" alt="banner" class="banner-img" />
            <div class="no-image" *ngIf="!banner.image_url">No image</div>
          </div>
        </div>

        <div class="detail-divider"></div>

        <!-- Info -->
        <div class="detail-section">
          <h2 class="section-title">Details</h2>
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">Status</span>
              <span class="badge" [class.badge-active]="banner.is_active" [class.badge-inactive]="!banner.is_active">
                {{ banner.is_active ? 'Active' : 'Inactive' }}
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">Slot</span>
              <span class="info-value">{{ slotLabel(banner.slot) }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Type</span>
              <span class="info-value">{{ banner.kind === 'sponsored' ? 'Sponsored' + (banner.sponsor_name ? ' · ' + banner.sponsor_name : '') : 'Internal' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Media</span>
              <span class="info-value">{{ banner.media_type === 'video' ? 'Video' + (banner.video_duration ? ' · ' + banner.video_duration + 's' : '') : 'Image' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Caption</span>
              <span class="info-value">{{ banner.caption_en || banner.caption_ar || '—' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Opens</span>
              <span class="info-value">{{ targetLabel(banner.target_type) }}{{ banner.target_id ? ' #' + banner.target_id : '' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Order</span>
              <span class="info-value">{{ banner.sort_order }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Schedule</span>
              <span class="info-value">{{ banner.starts_at ? (banner.starts_at | date:'medium') : 'Anytime' }} → {{ banner.ends_at ? (banner.ends_at | date:'medium') : 'No end' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Phone</span>
              <span class="info-value">{{ banner.phone || '—' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Link</span>
              <a *ngIf="banner.link" [href]="banner.link" target="_blank" class="info-link">
                {{ banner.link }}
              </a>
              <span *ngIf="!banner.link" class="info-value">—</span>
            </div>
            <div class="info-item">
              <span class="info-label">Created At</span>
              <span class="info-value">{{ banner.created_at | date:'medium' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Updated At</span>
              <span class="info-value">{{ banner.updated_at | date:'medium' }}</span>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- ── EDIT MODE ── -->
    <div *ngIf="isEditMode">
      <div class="error-msg" *ngIf="errorMessage">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/>
          <line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
        {{ errorMessage }}
      </div>

      <form class="form-card" (ngSubmit)="saveEdit()">

        <app-banner-fields [form]="editForm" [developers]="developers"></app-banner-fields>

        <div class="form-divider"></div>

        <div class="form-actions">
          <button type="button" class="btn-secondary" (click)="cancelEdit()">Cancel</button>
          <button type="submit" class="btn-primary" [disabled]="isSubmitting">
            <span *ngIf="!isSubmitting">Save Changes</span>
            <span *ngIf="isSubmitting" class="spinner-sm"></span>
          </button>
        </div>

      </form>
    </div>

  </ng-container>

  <!-- ── Delete Confirmation Modal ── -->
  <div class="modal-overlay" *ngIf="showDeleteModal">
    <div class="modal-confirm">
      <div class="modal-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/>
          <path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
        </svg>
      </div>
      <h3>Delete Banner</h3>
      <p>Are you sure you want to delete <strong>Banner #{{ banner?.id }}</strong>? This action cannot be undone.</p>
      <div class="modal-btns">
        <button class="btn-secondary" (click)="cancelDelete()">Cancel</button>
        <button class="btn-danger-solid" (click)="deleteBanner()" [disabled]="isDeleting">
          <span *ngIf="!isDeleting">Yes, Delete</span>
          <span *ngIf="isDeleting" class="spinner-sm"></span>
        </button>
      </div>
    </div>
  </div>

</div>
